export const FETCH_USER = "fetch_user";
export const LOGOUT = "logout";
export const FETCH_PROGRAMS = "fetch_programs";
export const FETCH_APPLICATIONLIST = "fetch_applicationlist";
export const CHECK_TOKEN = "check_token";
export const UPDATE_DATA = "update_data";
export const GET_DEPARTMENTS = "get_departments";
export const FORGET_PASSWORD = "forget_password";
export const USER_DETAIL_OTP_FORGOTPASS = "user_detail_otp_forgotpass";



// WEBPACK FOOTER //
// ./src/login/types.js